<template>
    <div class="">
      <div class="row justify-content-center py-5">
        <div class="col-md-8  justify-content-center">
          <h2 class="headline2 rowschatten p-4">
            Vertrauen Sie auf unser Know-how von der Planung bis zur Umsetzung.
            </h2>
        </div>
      </div>  
      <div class="row justify-content-center pb-5">
        <div class="col-md-8  justify-content-center">
          <h2 class="headline2 rowschatten p-4">
              Wir stehen für Qualität, Präzision und individuelle Lösungen im Innenausbau.
            </h2>
        </div>
      </div> 

      <div class="row justify-content-center pb-5  bildschirnansicht  ">
          <div class="col-md-8 grauHintergrund">
            
            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-2">
                <img
                  src="../assets/balkenMitBild/balkenMitBild1.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten"
                />
              </div>
              <div class="col-md-10 p-4">
                <p class="kachelHeader pb-3">Die Firma Lichtetal-Trockenbau</p>
                <span class="kachelText"
                  >Seit 1999 ist sie deutschlandweit Ihr kompetenter Partner für den
                  Innenausbau.</span
                >
              </div>
            </div>

            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-10 p-4">
                <p class="kachelHeader pb-3">Kompletter Innenausbau</p>
                <span class="kachelText"
                  >Gestalten Sie mit uns Ihren gesamten Innenausbau. Für ein neues Wohngefühl in Ihren Räumen</span
                >
              </div>
              <div class="col-md-2">
                <img
                  src="../assets/balkenMitBild/balkenMitBild8.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten"
                />
              </div>
            </div>

            
            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-2">
                <img
                  src="../assets/balkenMitBild/balkenMitBild2.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten"
                />
              </div>
              <div class="col-md-10 p-4">
                <p class="kachelHeader pb-3">Trockenbau, Decken, Wände oder Böden</p>
                <span class="kachelText"
                  >Wir bieten vielfältige Gestaltungsvarianten, individuell abgestimmt
                  auf Ihre Wünsche.</span
                >
              </div>
            </div>
          

            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-10 p-4">
                <p class="kachelHeader pb-3">Fliesen und Bodenbeläge aller Art</p>
                <span class="kachelText"
                  >Besuchen Sie unsere reichhaltige Fliesenausstellung und lassen Sie sich fachkundig beraten.</span
                >
              </div>
              <div class="col-md-2">
                <img
                  src="../assets/balkenMitBild/balkenMitBild7.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten"
                />
              </div>
            </div>

            
            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-2">
                <img
                  src="../assets/balkenMitBild/balkenMitBild3.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten"
                />
              </div>
              <div class="col-md-10 p-4">
                <p class="kachelHeader pb-3">Türen, Fenster und Treppen</p>
                <span class="kachelText"
                  >Sie erhalten alles bei uns aus einer Hand.</span
                >
              </div>
            </div>
            

            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-10 p-4">
                <p class="kachelHeader pb-3">Unsere Leistungen gehen über die reine Bauausführung hinaus</p>
                <span class="kachelText"
                  >Wir beraten  Sie umfassend und planen gemeinsam mit Ihnen Ihr Projekt.</span
                >
              </div>
              <div class="col-md-2">
                <img
                  src="../assets/balkenMitBild/balkenMitBild4.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten"
                />
              </div>
            </div>
            

            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-2">
                <img
                  src="../assets/balkenMitBild/balkenMitBild5.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten"
                />
              </div>
              <div class="col-md-10 p-4">
                <p class="kachelHeader pb-3">Dank unserer Flexibilität</p>
                <span class="kachelText"
                  >Wir können Ihnen eine unkomplizierte,
                  zuverlässige Zusammenarbeit zusichern.</span
                >
              </div>
            </div>
            

            <div class="row p-2 m-4 hellgrauHintergrund">
              <div class="col-md-8 p-4">
                <p class="kachelHeader pb-3">LTB Unterweißbach GmbH Lichtetal-Trockenbau</p>
                <span class="kachelText"
                  >Ihr Partner für hochwertige Trockenbauarbeiten. Wir freuen uns auf Ihre Anfrage!</span
                >
              </div>
              <div class="col-md-4">
                <img
                  src="../assets/balkenMitBild/balkenMitBild6.jpg"
                  alt="ltb-logo"
                  class="img-fluid bildschatten p-2 bg-white"
                />
              </div>
            </div>

          </div>
        </div>
      </div>  
</template>